import type { ExecuteShareTaskResponse } from '../types';

export const DuplicateExecuteApi = Symbol('DuplicateExecuteApi');

export interface DuplicateExecuteApi {
  executeShareTask(data: string): Promise<ExecuteShareTaskResponse>;
}
